import { createEvent } from "effector";
function OnChangeSearchParamEvt() {
    const onChangeSearchParamEvt = createEvent("OnChangeSearchParamEvt");
    onChangeSearchParamEvt.watch(() => console.log("OnChangeSearchParamEvt"));
    return onChangeSearchParamEvt;
}
export default OnChangeSearchParamEvt;
//# sourceMappingURL=OnChangeSearchParamEvt.js.map